import { appEntry } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="relative rounded-2xl overflow-hidden shadow-sm">
              <img
                src={appEntry.image}
                alt="牛牛影视 APP"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">{appEntry.title}</h2>
            <p className="mt-1 text-sm text-primary-500 font-medium">{appEntry.subtitle}</p>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">{appEntry.desc}</p>
            <div className="mt-5 flex flex-wrap items-center justify-center lg:justify-start gap-3">
              {appEntry.features.map((f) => (
                <span key={f} className="px-3 py-1.5 rounded-full bg-background-50 text-xs text-foreground-600 font-medium border border-background-200/70 whitespace-nowrap">
                  {f}
                </span>
              ))}
            </div>
            <div className="mt-6 flex items-center justify-center lg:justify-start gap-3">
              <a href="#contact" className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i> App Store
              </a>
              <a href="#contact" className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill text-lg"></i> Android 下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}